import { render } from "./Card.vue?vue&type=template&id=765cca32&scoped=true"
import script from "./Card.vue?vue&type=script&lang=js"
export * from "./Card.vue?vue&type=script&lang=js"

import "./Card.vue?vue&type=style&index=0&id=765cca32&scoped=true&lang=css"
import "./Card.vue?vue&type=style&index=1&id=765cca32&lang=css"

import exportComponent from "/voc/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-765cca32"]])

export default __exports__